import { FC } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import css from "./sidebar.module.scss";

const Sidebar: FC = () => {
    const navigate = useNavigate();
    const onLogOut = async () => {
        localStorage.clear();
        navigate("/");
    };

    return (
        <div className={css["sidebar-container"]}>
            <div className={css["sidebar-wrapper"]}>
                <div className={css["sidebar-list"]}>
                    <ul className={css["sidebar-items"]}>
                        <li>
                            {/* <NavLink to={"/orders"}>
                                {({ isActive }) => (
                                    <div className={css[`sidebar-item${isActive ? "-active" : ""}`]}>
                                        <div>
                                            <i className="pi pi-shopping-cart" style={{ fontSize: "1.2rem" }}></i>
                                            <span style={{ marginLeft: "8px" }}>Orders</span>
                                        </div>
                                    </div>
                                )}
                            </NavLink>
                            <NavLink to={"/products"}>
                                {({ isActive }) => (
                                    <div className={css[`sidebar-item${isActive ? "-active" : ""}`]}>
                                        <div>
                                            <i className="pi pi-shopping-cart" style={{ fontSize: "1.2rem" }}></i>
                                            <span style={{ marginLeft: "8px" }}>Products</span>
                                        </div>
                                    </div>
                                )}
                            </NavLink> */}
                            <NavLink to={"/logs"}>
                                {({ isActive }) => (
                                    <div className={css[`sidebar-item${isActive ? "-active" : ""}`]}>
                                        <div>
                                            <i className="pi pi-align-justify" style={{ fontSize: "1.2rem" }}></i>
                                            <span style={{ marginLeft: "8px" }}>Logs</span>
                                        </div>
                                    </div>
                                )}
                            </NavLink>
                            <NavLink to={"/subscription"}>
                                {({ isActive }) => (
                                    <div className={css[`sidebar-item${isActive ? "-active" : ""}`]}>
                                        <div>
                                            <i className="pi pi-dollar" style={{ fontSize: "1.2rem" }}></i>
                                            <span style={{ marginLeft: "8px" }}>Subscription</span>
                                        </div>
                                    </div>
                                )}
                            </NavLink>
                            <NavLink to={"/settings"}>
                                {({ isActive }) => (
                                    <div className={css[`sidebar-item${isActive ? "-active" : ""}`]}>
                                        <div>
                                            <i className="pi pi-cog" style={{ fontSize: "1.2rem" }}></i>
                                            <span style={{ marginLeft: "8px" }}>Settings</span>
                                        </div>
                                    </div>
                                )}
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
            <div onClick={() => onLogOut()} className={css["logout-container"]}>
                <div className={css["logout-title"]}>Logout</div>
            </div>
        </div>
    );
};

export default Sidebar;
